import { ConnectFlowAudioModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class ConnectFlowAudioService extends BaseService<ConnectFlowAudioModel> {}

export default new ConnectFlowAudioService('audios');
